import Component from "react-pure-render/component";
import React from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import Wysiwyg from "../components/wysiwyg.react";
import InputCustom from "../components/inputCustom.react";
import Media from "./media.react";
import Modal from "../components/modal.react";
import Select from "react-select";
import Dropzone from "react-dropzone";
import Isvg from "react-inlinesvg";
import Pagination from "../components/pagination/pagination.react";
import MediasModal from "./mediasModal.react";

export default class MediaEdit extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {
      field,
      actions,
      mediaCategories,
      mediaCategoriesSearch,
      notificationSystem,
      medias,
      meta
    } = this.props;

    if (field.get("fieldType") === "mediaImage" && field.get("value")) {
      actions.getMedia(field.get("value")).then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
      });
    }

    if (mediaCategories.first()) {
      if (!mediaCategoriesSearch.get("uid")) {
        actions.setSearchField(
          "mediaCategories",
          "uid",
          mediaCategories.first().get("uid")
        );
        actions
          .getMediaCategoryMedias(mediaCategories.first().get("uid"), meta)
          .then(({ error, payload }) => {
            if (error) {
              addNotificationsForInvalidFields(payload, notificationSystem);
            }
          });
      } else {
        actions
          .getMediaCategoryMedias(mediaCategoriesSearch.get("uid"), meta)
          .then(({ error, payload }) => {
            if (error) {
              addNotificationsForInvalidFields(payload, notificationSystem);
            }
          });
      }
    }
  }

  openEditMediaModal = () => {
    const { actions, field } = this.props;
    actions.setIsEditPageTranslationMediaFieldModalVisible(field.get("uid"));
  };

  closeEditMediaFieldModal = () => {
    const { actions } = this.props;
    actions.selectMediaItem(null);
    actions.setIsEditPageTranslationMediaFieldModalVisible(false);
  };

  editMedia = () => {
    const { actions, field, selectedMediaItem } = this.props;
    if (selectedMediaItem) {
      const item = selectedMediaItem.toArray()[0];
      actions.setEntityField("fields", field.get("uid"), "value", item);
      actions.setEntityField(
        "fields",
        field.get("uid"),
        "fieldType",
        "mediaImage"
      );
    }
    actions.setIsEditPageTranslationMediaFieldModalVisible(false);
    actions.selectMediaItem(null);
  };

  onMediaCategorySelect = value => {
    if (value) {
      const { actions, notificationSystem, medias, meta } = this.props;
      actions.setSearchField("mediaCategories", "uid", value);
      actions.getMediaCategoryMedias(value, meta).then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
      });
    }
  };

  onFileSubmit = files => {
    const self = this;
    const {
      actions,
      notificationSystem,
      mediaCategoriesSearch,
      medias,
      meta
    } = this.props;

    files.forEach(function(file, index) {
      actions.uploadFile(file).then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          actions
            .createMediaCategoryMedia(
              {
                name: payload.name,
                description: "",
                fileUID: payload.uid
              },
              mediaCategoriesSearch.get("uid")
            )
            .then(({ error, payload }) => {
              if (error) {
                addNotificationsForInvalidFields(payload, notificationSystem);
              } else {
                actions
                  .getMediaCategoryMedias(
                    mediaCategoriesSearch.get("uid"),
                    meta
                  )
                  .then(({ error, payload }) => {
                    if (error) {
                      addNotificationsForInvalidFields(
                        payload,
                        notificationSystem
                      );
                    }
                  });
              }
            });
        }
      });
    });
  };

  paginationAction = page => {
    const {
      actions,
      notificationSystem,
      meta,
      params,
      mediaCategoriesSearch
    } = this.props;
    actions.setPaginationPage("medias", page);
    let mediasMeta = meta.toJS();
    mediasMeta.currentPage = page;
    actions
      .getMediaCategoryMedias(mediaCategoriesSearch.get("uid"), mediasMeta)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
      });
  };

  generateEditMediaModal = () => {
    const {
      apiHost,
      medias,
      mediasResults,
      mediaCategoriesSearch,
      mediaCategories,
      selectedMediaItem,
      actions,
      field,
      meta
    } = this.props;

    let mediaCategoriesSelectOptions = [];
    mediaCategories.forEach(function(mediaCategory, index) {
      mediaCategoriesSelectOptions.push({
        value: mediaCategory.get("uid"),
        label: mediaCategory.get("name")
      });
    });

    const mediasHTML = mediasResults.map(function(mediaUID, index) {
      if (
        medias.getIn([mediaUID, "mediaCategoryUID"]) ===
        mediaCategoriesSearch.get("uid")
      ) {
        return (
          <Media
            key={index}
            actions={actions}
            apiHost={apiHost}
            media={medias.get(mediaUID)}
            selectedMediaItem={selectedMediaItem}
            apiHost={apiHost}
            field={field}
            medias={medias}
          />
        );
      }
    });

    return (
      <Modal
        closeModalAction={this.closeEditMediaFieldModal}
        enterAction={this.editMedia}
        handleKeyDownEvent={true}
      >
        <div className="row middle-xs">
          <h3 className="col-xs-12 col-sm-6">Wybierz media: </h3>
          <div className="col-xs-12 col-sm-6">
            <Select
              name="select-media-category"
              value={mediaCategoriesSearch.get("uid")}
              options={mediaCategoriesSelectOptions}
              onChange={this.onMediaCategorySelect}
              clearable={false}
            />
          </div>

          <div className="col-xs-12 media-item">
            <div className="row">{mediasHTML}</div>
            <Pagination
              numberOfPages={Math.ceil(meta.all / meta.limit)}
              setPageAction={this.paginationAction}
              maxPagesDisplay={5}
              currentPage={meta.currentPage + 1}
            />
          </div>
          <button className="info" onClick={this.editMedia}>
            Wybierz
          </button>
          <button className="info" onClick={this.closeEditMediaFieldModal}>
            Anuluj
          </button>
        </div>
        <Dropzone
          onDrop={this.onFileSubmit}
          className="dropzone"
          activeClassName="dropzone-active"
        >
          <div>
            <Isvg className="dropzone-icon" src="/assets/img/icon_upload.svg" />
            <p className="dropzone-text">Upuść lub kliknij aby dodać zdjęcia</p>
          </div>
        </Dropzone>
      </Modal>
    );
  };

  removeAction = () => {
    const { removeAction, field } = this.props;
    removeAction(field.get("uid"));
  };

  render() {
    const {
      apiHost,
      medias,
      mediasResults,
      mediasMeta,
      mediaCategoriesSearch,
      mediaCategories,
      selectedMediaItem,
      actions,
      field,
      meta,
      notificationSystem,
      isEditMediaFieldModalVisible,
      loading,
      isRemoveButtonVisible
    } = this.props;
    const editMediaModal = this.generateEditMediaModal();
    return (
      <div className="col-xs-12">
        <div className="content-wrapper section">
          <div className="section-title">
            <span>{field.get("name")}</span>
            {isRemoveButtonVisible && (
              <button classname="error" onClick={this.removeAction}>
                usuń pole
              </button>
            )}
          </div>
          {field.get("fieldType") === "mediaImage" &&
          medias.getIn([field.getIn(["value"]), "fileUID"]) && (
            <div className="media-image" onClick={this.openEditMediaModal}>
              <img
                src={`${apiHost}/v1/files/${medias.getIn([
                  field.getIn(["value"]),
                  "fileUID"
                ])}/file`}
                onClick={this.openEditMediaModal}
              />
              <div className="hover-background">
                <Isvg src="/assets/img/icon_edit.svg" />
              </div>
            </div>
          )}
          {field.get("fieldType") === "imageURL" &&
          field.get("value") && (
            <img src={field.get("value")} onClick={this.openEditMediaModal} />
          )}
          {field.get("fieldType") === "mediaImage" &&
          field.get("value") &&
          !medias.getIn([field.get("value"), "fileUID"]) &&
          !loading && (
            <div onClick={this.openEditMediaModal} className="dropzone">
              <p className="dropzone-text">
                Nie odnaleziono obrazka. Kliknij tu aby ponownie dodać obrazek.
              </p>
            </div>
          )}
          {!field.get("value") && (
            <div onClick={this.openEditMediaModal} className="dropzone">
              <p className="dropzone-text">Kliknij tu aby dodać obrazek</p>
            </div>
          )}
        </div>
        {isEditMediaFieldModalVisible === field.get("uid") && (
          <MediasModal
            closeModalAction={this.closeEditMediaFieldModal}
            mainAction={this.editMedia}
            actions={actions}
            notificationSystem={notificationSystem}
            mediaCategoriesSearch={mediaCategoriesSearch}
            medias={medias}
            mediaCategories={mediaCategories}
            selectedMediaItem={selectedMediaItem}
            apiHost={apiHost}
            mediasResults={mediasResults}
            meta={meta}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/mediaEdit.react.js